import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { Loader } from 'components/Loader';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { SiteSetupDetailsContent as SiteSetupDetailsContentComponent } from './SiteSetupDetailsContent';

import { useGetSiteSetupQuery, useSiteSetupUpdatedSubscription } from 'data/__generated__';
import { siteSetupUpdatedHandler } from '../cacheHandlers/siteSetupsCacheHandler';

type ParamTypes = {
    siteSetupId: string;
};

export const SiteSetupDetails = () => {
    const { siteSetupId = '' } = useParams<ParamTypes>();

    const {
        loading: siteSetupLoading,
        data: siteSetupData,
        error: siteSetupError,
    } = useGetSiteSetupQuery({
        variables: { siteSetupId },
    });

    useSiteSetupUpdatedSubscription({
        variables: { siteSetupId },
        onData({ data: { data } }) {
            if (!data) {
                return;
            }
            const { siteSetupUpdated } = data;
            siteSetupUpdatedHandler(siteSetupUpdated);
        },
    });

    if (siteSetupLoading) {
        return (
            <Container>
                <Loader />
            </Container>
        );
    }

    if (siteSetupError || !siteSetupData) {
        throw new Error(`L'erreur suivante est survenue : ${siteSetupError}`);
    }

    const { getSiteSetup: siteSetup } = siteSetupData;

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.siteSetupDetails} />
                </HeaderTitle>
                <CTAsContainer>
                    <Link to="/site-setups">
                        <TotemPrimaryButton $isSecondaryStyle>Retour</TotemPrimaryButton>
                    </Link>
                </CTAsContainer>
            </Header>
            <SiteSetupDetailsContentComponent siteSetup={siteSetup} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const CTAsContainer = styled.div`
    display: flex;
    align-items: center;

    & > :not(:first-child) {
        margin-left: 5px;
    }
`;
